import React from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useSubscription } from '@trpc/tanstack-react-query';

import { trpc } from '../lib/trpc';
import { invalidateRoutes } from '../utils/entityChangeCache';
import { useAuth } from './AuthContext';

export function EntityChangeProvider({ children }: { children: React.ReactNode }) {
  const { user, isLoading: authLoading } = useAuth();
  const queryClient = useQueryClient();

  useSubscription(
    trpc.entityChanges.onEntityChange.subscriptionOptions(undefined, {
      enabled: !authLoading && !!user,
      onData: (event: { routes: string[] }) => {
        // A push-driven cache nudge: nothing downstream waits on it, and the
        // subscription callback must not block on a refetch.
        void invalidateRoutes(queryClient, event.routes);
      },
      onError: (error) => {
        console.error('Entity change subscription error:', error);
      },
    }),
  );

  return <>{children}</>;
}
